export class TripOverviewList {
  tripHashId: string;
  Id: string;
  locationExchangeId: string;
  startDateTime: string;
  endDateTime : string;
  startLatitude : string;
  startLongitude: string;
  endLatitude: string;
  endLongitude : boolean;
  distanceInMeters: string;
  tripReceiveDateTime: string;
  tripReadDateTime: string;
  rfidTag: string;
  licensePlate: string;
  nrOpenAnswers: number;
  isQuestionAnswered: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/trip/models/trip-overviewlist.model.ts